import prompts from "./prompts";
import rooms from "./rooms";

export const chat = {
    prompts,
    rooms,
};

export default chat;
